module.exports = __webpack_public_path__ + "img/5.fd086fe2.jpg";